import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取banner信息 **/
    GET_BANNER_LIST(data) {
        controller='EsXcxad';
        action='GetBannerList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 更新banner信息 **/
    UPDATE_BANNER(data) {
        controller='EsXcxad';
        action='UpdateBanner';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增banner信息 **/
    ADD_BANNER(data) {
        controller='EsXcxad';
        action='AddBanner';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除Banner **/
    DEL_BANNER(data) {
       controller='EsXcxad';
       action='DelBanner';
       url='/'+controller+'/'+action;
       return api({ url: url, method: "post", data: data }); 
    },

    /** 获取分类信息 **/
    GET_CATE_LIST(data) {
        controller='EsXcxad';
        action='GetCateList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
     },

    /** 更新分类信息 **/
    UPDATE_CATE(data) {
        controller='EsXcxad';
        action='UpdateCate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增分类信息 **/
    ADD_CATE(data) {
        controller='EsXcxad';
        action='AddCate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除分类 **/
    DEL_CATE(data) {
        controller='EsXcxad';
        action='DelCate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
     },

     /** 获取导航信息 **/
     GET_NAV_LIST(data) {
        controller='EsXcxad';
        action='GetNavList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
     },

     /** 更新导航信息 **/
     UPDATE_NAV(data) {
        controller='EsXcxad';
        action='UpdateNav';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
     },

     /** 新增导航信息 **/
     ADD_NAV(data) {
        controller='EsXcxad';
        action='AddNav';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
     },

     /** 删除导肮信息 **/
     DEL_NAV(data) {
        controller='EsXcxad';
        action='DelNav';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
     },

     /** 获取首页设置显示 **/
     GET_SHOW_LIST(data) {
        controller='EsXcxad';
        action='GetShowList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
     },

     /** 获取跳转类型 **/
     GET_JUMP_TYPE(data) {
      controller='EsXcxad';
      action='GetJumpTypes';
      url='/'+controller+'/'+action;
      return api({ url: url, method: "post", data: data }); 
     },

   
}